if (!customElements.get('bulk-order-form')) {
  customElements.define(
    'bulk-order-form',
    class BulkOrderForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
        this.itemsContainer = this.querySelector('[data-items]');
        this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorWrapper ? this.errorWrapper.querySelector('.product-form__error-message') : null;

        this.addEventListener('submit', this.onSubmit.bind(this), true);
        this.addEventListener('input', this.clampQuantity.bind(this));
      }

      clampQuantity(event) {
        const input = event.target;
        if (!input.classList || !input.classList.contains('bulk-order-form__qty')) return;

        let value = parseInt(input.value, 10);
        if (isNaN(value)) return;

        const min = input.min !== '' ? parseInt(input.min, 10) : 0;
        if (value < min) value = min;

        if (input.max !== '') {
          const max = parseInt(input.max, 10);
          if (!isNaN(max) && value > max) value = max;
        }

        if (String(value) !== input.value) input.value = value;
        this.showError(false);
      }

      collectItems() {
        const items = [];
        this.querySelectorAll('.bulk-order-form__qty').forEach((input) => {
          if (input.disabled) return;
          let quantity = parseInt(input.value, 10);
          const id = input.dataset.variantId;
          if (input.max !== '') {
            const max = parseInt(input.max, 10);
            if (!isNaN(max) && quantity > max) quantity = max;
          }
          if (id && quantity > 0) {
            items.push({ id, quantity });
          }
        });
        return items;
      }

      onSubmit(event) {
        const items = this.collectItems();

        if (items.length === 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError(this.dataset.emptyError || 'Please enter a quantity.');
          return;
        }

        this.showError(false);

        if (this.idInput) this.idInput.disabled = true;
        this.itemsContainer.innerHTML = '';
        items.forEach((item, index) => {
          this.itemsContainer.appendChild(this.hiddenInput(`items[${index}][id]`, item.id));
          this.itemsContainer.appendChild(this.hiddenInput(`items[${index}][quantity]`, item.quantity));
        });
      }

      hiddenInput(name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        return input;
      }

      showError(message) {
        if (!this.errorWrapper) return;
        this.errorWrapper.toggleAttribute('hidden', !message);
        if (message && this.errorMessage) this.errorMessage.textContent = message;
      }
    }
  );
}
